import { ChipButton, ChipButtonContainer, ContentHeader, IconArrowRightBold, Text } from '@croquiscom-pvt/zds';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { SwiperSlide } from 'swiper/react';

import { Log } from '@common/log-manager';
import { ProductCardCarousel } from '@common/product-card';
import {
  BestProductCarouselComponentType,
  MoreButton as ProductCarouselMoreButton,
  useProductCardEvents,
} from '@domains/storehome-common';

import { useBestProductCarouselService } from '../services/useBestProductCarouselService';

interface Props {
  log?: Partial<Log>;
  shop_id: string;
  category_id?: string;
  component: BestProductCarouselComponentType;
}

export const BestProductCarouselContainer = ({ log, shop_id, category_id, component }: Props) => {
  const { header } = component;
  const {
    selectedId,
    tabs,
    carouselMoreButtonWidth,
    handleTabChange,
    handleCarouselMoreButtonClick,
    actionButton,
    productCardList,
    handleMoreButtonClick,
    columnCount,
  } = useBestProductCarouselService({
    shop_id,
    category_id,
    component,
  });
  const { onClick, onImpression, onLikeClick } = useProductCardEvents();

  return (
    <Wrap>
      <ContentHeader
        title={header?.title?.text ?? ''}
        right={
          header.button
            ? {
                type: 'text-button',
                icon: IconArrowRightBold,
                text: header.button.text?.text ?? '',
                onClick: () => handleMoreButtonClick(),
              }
            : undefined
        }
      />
      <ChipButtonContainer.Scrollable
        css={css`
          > div {
            padding: 0 16px 8px;
          }
        `}
      >
        {tabs.map((tab) => (
          <ChipButton.Filter key={tab.id} selected={selectedId === tab.id} onClick={() => handleTabChange(tab.id)}>
            {tab.name}
          </ChipButton.Filter>
        ))}
      </ChipButtonContainer.Scrollable>
      <ProductCardCarousel.Root navigation={productCardList.length > 3} slidesPerView={columnCount} key={selectedId}>
        <ProductCardCarousel.VerticalProductCardSlideItems
          items={productCardList}
          onClick={(item, index, event) =>
            onClick(event, item, index, log && { ...log, ...(category_id && { category_id }), object_idx: index })
          }
          onImpression={(item, index) =>
            onImpression(item, index, log && { ...log, ...(category_id && { category_id }), object_idx: index })
          }
          onLikeClick={(is_liked, item, index) =>
            onLikeClick(
              is_liked,
              item,
              index,
              log && { ...log, ...(category_id && { category_id }), object_idx: index },
            )
          }
        />
        {actionButton && (
          <SwiperSlide style={{ width: carouselMoreButtonWidth, minWidth: 96 }}>
            <ProductCarouselMoreButton onClick={() => handleCarouselMoreButtonClick()} text={actionButton.text} />
          </SwiperSlide>
        )}
      </ProductCardCarousel.Root>
    </Wrap>
  );
};

const Wrap = styled.section`
  position: relative;
  padding-bottom: 20px;
`;
